import React from 'react';
import { styled } from '../../../stitches.config';
import Box from '../Box';

export default props => {
    const boxes = [
        { id: "b2", settings: props.settings.b2 },
        { id: "b3", settings: props.settings.b3 },
        { id: "b4", settings: props.settings.b4 },
        { id: "b5", settings: props.settings.b5 },
        { id: "b6", settings: props.settings.b6 },
    ];

    return (
        <div className="container">
            <Wrapper>
                <Box
                    key={"b1"}
                    id={"b1"}
                    type="BTagsTitle"
                    settings={props.settings.b1}
                />
                <TagsWrapper>
                    {boxes.map(
                        ({ id, settings }) =>
                            settings?.link && (
                                <Box
                                    key={id}
                                    {...props}
                                    id={id}
                                    type="BTags"
                                    settings={settings}
                                />
                            )
                    )}
                </TagsWrapper>
            </Wrapper>
        </div>
    );
};

export const Wrapper = styled("div", {
    margin: "0",
    marginTop: "20px",
    marginBottom: "20px",
    marginLeft: "-7px",
    padding: "0",
    width: "100%",
    "span": {
        display: "block",
        flexBasis: "100%",
        fontSize: "19px",
        fontWeight: 700,
        marginLeft: "7px",
        marginBottom: "5px",
        color: "$grayscale100"
    },
    a: {
        display: "inline-block",
        color: "$primary",
        fontSize: "13px",
        fontWeight: 700,
        margin: "0 7px"
    }
});

export const TagsWrapper = styled("ul", {
    display: "flex",
    listStyle: "none",
    flexWrap: "wrap",
    width: "100%",
    padding: "0px",
});

